import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetPeriodsattPeriodCommand extends BasicCommand<SetPeriodsattPeriodCommand> {
    get primaryKey(): IPrimaryKey<SetPeriodsattPeriodCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    periodsattPeriod?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetPeriodsattPeriodCommand";
    constructor(init: (instance: SetPeriodsattPeriodCommand) => void) {
        super(SetPeriodsattPeriodCommand.$type, SetPeriodsattPeriodCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
